import React from 'react';

const Icon = ({ size = '49', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 49 49" fill="none" {...other}>
            <g clipPath="url(#a)">
                <path opacity="0.01" fill="#D8D8D8" d="M0 .541h48.649V49.19H0z" />

                <circle cx="33.744" cy="31.081" r="5.676" stroke="black" strokeWidth="2.162" />

                <path
                    d="M22.163 24.865c2.45 0 4.747.626 6.729 1.72a7.039 7.039 0 0 0-1.218 1.822 11.578 11.578 0 0 0-5.51-1.38c-5.825 0-10.616 4.244-11.202 9.686-.067.618-.564 1.124-1.186 1.124s-1.131-.505-1.076-1.125c.594-6.638 6.395-11.847 13.463-11.847Z"
                    fill="black"
                />

                <rect x="30.771" y="30.27" width="5.946" height="1.622" rx="0.811" fill="black" />

                <rect x="34.555" y="28.108" width="5.946" height="1.622" rx="0.811" transform="rotate(90 34.555 28.108)" fill="black" />

                <path
                    d="M22.163 23.784a6.486 6.486 0 1 0 0-12.973 6.486 6.486 0 0 0 0 12.973Z"
                    stroke="black"
                    strokeWidth="2.162"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="white" d="M0 0h48.649v48.649H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
